import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const FlixMedia = () => {
  const location = useLocation();
  const { ean, mpn } = location.state || {};

  useEffect(() => {
    const loadFlixScript = () => {
      console.log("Initializing Flix script...");

      // Reset previous Flix content if present
      if (typeof window.flixJsCallbacks === "object" && typeof window.flixJsCallbacks.reset !== "undefined") {
        window.flixJsCallbacks.reset();
        console.log("Flix content reset");
      }

      // Check if EAN and MPN are available
      if (!ean || !mpn) {
        console.error("EAN or MPN not provided!");
        return;
      }

      // Set global variables for Flix
      const distributor = "17909";
      const product_brand = "Samsung";
      const language = "gh";
      const fallbackLanguage = "en";
      const product_ean = ean;
      const product_mpn = mpn;

      // Remove any existing script to avoid duplicates
      const existingScript = document.querySelector("script[data-flix-distributor]");
      if (existingScript) {
        existingScript.remove();
        console.log("Removed existing Flix script.");
      }

      // Create the Flix script with required attributes
      const flixScript = document.createElement("script");
      flixScript.type = "text/javascript";
      flixScript.async = true;
      flixScript.src = "//media.flixfacts.com/js/loader.js";
      flixScript.setAttribute("data-flix-distributor", distributor);
      flixScript.setAttribute("data-flix-language", language);
      flixScript.setAttribute("data-flix-fallback-language", fallbackLanguage);
      flixScript.setAttribute("data-flix-brand", product_brand);
      flixScript.setAttribute("data-flix-ean", product_ean);
      flixScript.setAttribute("data-flix-mpn", product_mpn);
      flixScript.setAttribute("data-flix-inpage", "flix-inpage");
      flixScript.setAttribute("data-flix-button", "flix-minisite");
      flixScript.setAttribute("data-flix-price", "");

      flixScript.onload = () => {
        console.log("Flix script loaded successfully with EAN:", product_ean, "and MPN:", product_mpn);
      };

      flixScript.onerror = () => {
        console.error("Failed to load Flix script");
      };

      // Append the script to the document head
      document.head.appendChild(flixScript);
      console.log("Flix script appended to head.");
    };

    loadFlixScript();
  }, [ean, mpn]);

  return (
    <div id="DescriptionSectionOfYourPage">
      <div id="flix-inpage"></div>
      <div id="flix-minisite"></div>
    </div>
  );
};

export default FlixMedia;
